class FormCustomCheckbox {
    constructor() {
        this.initListeners();
    }
    initListeners() {
        const customCheckBox = document.querySelector('.js-custom-checkbox');
        const realCheckBox = document.querySelector('#candidate-check');
        const customCheckBoxCheckedClass = "form-container__custom-checkbox_checked";
        realCheckBox.checked = true;
        customCheckBox.addEventListener('click', (event) => {
            if (customCheckBox.classList.contains(customCheckBoxCheckedClass)) {
                customCheckBox.classList.remove(customCheckBoxCheckedClass);
                realCheckBox.checked = false;
            } else {
                customCheckBox.classList.add(customCheckBoxCheckedClass);
                realCheckBox.checked = true;
            }
        });
    }
}

const formCustomCheckbox = new FormCustomCheckbox();
